import api from '@/http'
import axios from 'axios'
import crypto from 'crypto-js'
import { Str } from 'laravel-js-str'

export default {
  async requestAuthorization (context, params = {}) {
    // await revokeToken()

    if(!context.state.system) {
      await context.dispatch('getSystem')
      if(!context.state.system.ecosystem_app) {
        return
      }
    }

    localStorage.state = Str.random(40)
    localStorage.codeVerifier = Str.random(128)
    localStorage.intended = window.location.pathname !== '/oauth/login' ? `${window.location.pathname}${window.location.search}` : window.location.search

    const host = process.env.VUE_APP_ROOT_API

    const query = new URLSearchParams({
      client_id: context.state.system.ecosystem_app.oauth_client_id,
      redirect_uri: `${window.location.protocol}//${window.location.host}/oauth/login`,
      response_type: 'code',
      scope: '*',
      state: localStorage.state,
      code_challenge: crypto.SHA256(localStorage.codeVerifier).toString(crypto.enc.Base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ''),
      code_challenge_method: 'S256'
    })

    const query2 = new URLSearchParams({
      r: `/oauth/authorize?${query}`,
      force: params.force === undefined ? true : params.force,
      direct: params.direct === undefined ? false : params.direct
    })

    window.location.href = `${host}/login?${query2}`
  },

  async getToken (context, { state, code }) {
    if(!context.state.system) {
      await context.dispatch('getSystem')
      if(!context.state.system.ecosystem_app) {
        return
      }
    }

    const localState = localStorage.state
    const codeVerifier = localStorage.codeVerifier
    localStorage.removeItem('state')
    localStorage.removeItem('codeVerifier')
    if (localState !== state) {
      return Promise.reject(new Error('Unexpected state'))
    }

    const host = process.env.VUE_APP_ROOT_API

    const response = await axios.post(`${host}/oauth/token`, {
      grant_type: 'authorization_code',
      client_id: context.state.system.ecosystem_app.oauth_client_id,
      redirect_uri: `${window.location.protocol}//${window.location.host}/oauth/login`,
      code_verifier: codeVerifier,
      code: code
    })

    localStorage.accessToken = response.data.access_token
    localStorage.refreshToken = response.data.refresh_token

    return Promise.resolve(response)
  },

  logout (context) {
    localStorage.clear()
    context.dispatch('requestAuthorization')
  },

  getSystem (context) {
    return new Promise((resolve, reject) => {
      if (context.state.system) {
        resolve(context.state.system)
        return
      }

      api.get('/discover').then((response) => {
        context.commit('setSystem', response.data)
        resolve(response.data)

        const steps = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950]
        const base = `--color-base:${response.data.colour_base};`
        const accent = response.data.colour_accent.map((hex, i) => `--color-accent-${steps[i]}:${hex};`).join('')

        let cssVariables = document.getElementById('theme') || document.createElement('style')
        cssVariables.id = 'theme'
        cssVariables.innerHTML = `:root{${base}${accent};}`
        document.head.appendChild(cssVariables)

        if(response.data.favicon_url) {
          const iconEl = document.getElementById('favicon') || document.createElement('link')
          iconEl.id = 'favicon'
          iconEl.setAttribute('rel', 'icon')
          iconEl.setAttribute('href', response.data.favicon_url)
          document.head.appendChild(iconEl)
        }
      }, (error) => {
        reject(error)
      })
    })
  },

  fetchAuthUser (context) {
    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('accessToken')) {
        context.commit('setAuthUser', null)
        resolve(null)
        return
      }

      if (context.state.authUser) {
        resolve(context.state.authUser)
        return
      }

      api.get('/auth-user').then((response) => {
        if (!response || response.data.type != 7) {
          localStorage.clear()
          resolve(response.data)
          return
        }
        context.commit('setAuthUser', response.data)
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
}
